// Fix for ResizeObserver loop errors
// This is a known issue with ResizeObserver that occurs when callbacks
// take longer than a single animation frame to execute

export function installResizeObserverFix() {
  // Debounce ResizeObserver callbacks
  const debounce = (callback: Function, delay: number) => {
    let timeoutId: NodeJS.Timeout;
    return (...args: any[]) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => callback(...args), delay);
    };
  };

  // Override ResizeObserver
  const OriginalResizeObserver = window.ResizeObserver;
  
  window.ResizeObserver = class ResizeObserver {
    private observer: any;
    
    constructor(callback: ResizeObserverCallback) {
      // Debounce the callback to prevent loop errors
      const debouncedCallback = debounce(callback, 0);
      this.observer = new OriginalResizeObserver(debouncedCallback);
    }
    
    observe(target: Element, options?: ResizeObserverOptions) {
      this.observer.observe(target, options);
    }
    
    unobserve(target: Element) {
      this.observer.unobserve(target);
    }
    
    disconnect() {
      this.observer.disconnect();
    }
  } as any;

  // Also suppress the error if it still occurs
  const resizeObserverErrHandler = (e: ErrorEvent) => {
    if (e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
        e.message === 'ResizeObserver loop limit exceeded') {
      e.stopPropagation();
      e.stopImmediatePropagation();
      e.preventDefault();
      return true;
    }
  };
  
  window.addEventListener('error', resizeObserverErrHandler);
  
  // Cleanup function
  return () => {
    window.removeEventListener('error', resizeObserverErrHandler);
    window.ResizeObserver = OriginalResizeObserver;
  };
}